/* Flutter Care theme scripts — vanilla, module-scoped, Theme Editor safe. */
(function () {
  'use strict';

  var FC = {};

  /* ---------- helpers ---------- */
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function once(el, key) {
    if (!el || el.dataset['init' + key] === 'true') return false;
    el.dataset['init' + key] = 'true';
    return true;
  }

  /* ---------- mobile drawer ---------- */
  FC.drawer = function (scope) {
    $$('[data-drawer]', scope).forEach(function (drawer) {
      if (!once(drawer, 'Drawer')) return;
      var id = drawer.getAttribute('data-drawer');
      var openers = $$('[data-drawer-open="' + id + '"]');
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        drawer.classList.add('is-open');
        drawer.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
        var focusable = drawer.querySelector('[data-drawer-close]');
        if (focusable) focusable.focus();
        document.addEventListener('keydown', onKey);
      }
      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        if (lastFocus) lastFocus.focus();
      }
      function onKey(e) {
        if (e.key === 'Escape') close();
        if (e.key !== 'Tab') return;
        var items = $$('a[href], button:not([disabled]), input, select, textarea', drawer).filter(function (el) {
          return el.offsetParent !== null;
        });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      openers.forEach(function (btn) { btn.addEventListener('click', open); });
      $$('[data-drawer-close]', drawer).forEach(function (btn) { btn.addEventListener('click', close); });
      drawer.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-drawer-overlay')) close();
      });
    });
  };

  /* ---------- accordions ---------- */
  FC.accordion = function (scope) {
    $$('[data-accordion]', scope).forEach(function (root) {
      if (!once(root, 'Accordion')) return;
      var single = root.getAttribute('data-accordion') === 'single';
      $$('.accordion__trigger', root).forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (single && !isOpen) {
            $$('.accordion__trigger[aria-expanded="true"]', root).forEach(function (other) {
              other.setAttribute('aria-expanded', 'false');
              var p = document.getElementById(other.getAttribute('aria-controls'));
              if (p) p.setAttribute('data-open', 'false');
            });
          }
          trigger.setAttribute('aria-expanded', String(!isOpen));
          if (panel) panel.setAttribute('data-open', String(!isOpen));
        });
      });
    });
  };

  /* ---------- tabs / filter groups ---------- */
  FC.tabs = function (scope) {
    $$('[data-tabs]', scope).forEach(function (root) {
      if (!once(root, 'Tabs')) return;
      var tabs = $$('[role="tab"]', root);
      var panelScope = root.getAttribute('data-tabs-target')
        ? document.querySelector(root.getAttribute('data-tabs-target'))
        : root.closest('.shopify-section') || document;

      function select(tab) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
        var value = tab.getAttribute('data-tab-value');
        $$('[data-tab-panel]', panelScope).forEach(function (panel) {
          panel.hidden = !(value === 'all' || panel.getAttribute('data-tab-panel') === value);
        });
        $$('[data-tab-item]', panelScope).forEach(function (item) {
          var cats = (item.getAttribute('data-tab-item') || '').split('|');
          item.hidden = !(value === 'all' || cats.indexOf(value) !== -1);
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = tabs[(index + dir + tabs.length) % tabs.length];
          next.focus();
          select(next);
        });
      });
      var initial = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      if (initial) select(initial);
    });
  };

  /* ---------- select-based filtering (therapist directory) ---------- */
  FC.filters = function (scope) {
    $$('[data-filter-form]', scope).forEach(function (form) {
      if (!once(form, 'Filters')) return;
      var results = document.getElementById(form.getAttribute('data-results'));
      if (!results) return;
      var countEl = document.getElementById(form.getAttribute('data-count'));
      var emptyEl = document.getElementById(form.getAttribute('data-empty'));
      var countTemplate = countEl ? countEl.getAttribute('data-template') || 'Showing [count]' : '';

      function apply() {
        var selects = $$('select', form);
        var visible = 0;
        $$('[data-filter-item]', results).forEach(function (item) {
          var match = selects.every(function (select) {
            if (!select.value) return true;
            var values = (item.getAttribute('data-' + select.name) || '').toLowerCase();
            return values.split('|').indexOf(select.value.toLowerCase()) !== -1;
          });
          item.hidden = !match;
          if (match) visible++;
        });
        if (countEl) countEl.textContent = countTemplate.replace('[count]', visible);
        if (emptyEl) emptyEl.hidden = visible !== 0;
      }

      form.addEventListener('change', apply);
      $$('[data-filter-reset]', form.closest('.shopify-section') || document).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('select', form).forEach(function (s) { s.value = ''; });
          apply();
        });
      });
      apply();
    });
  };

  /* ---------- entrance reveal ---------- */
  FC.reveal = function (scope) {
    if (!document.body.classList.contains('allow-motion')) return;
    if (!('IntersectionObserver' in window)) return;
    var items = $$('[data-reveal]', scope).filter(function (el) { return once(el, 'Reveal'); });
    if (!items.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { observer.observe(el); });
  };

  /* ---------- marquee duplication ---------- */
  FC.marquee = function (scope) {
    $$('[data-marquee]', scope).forEach(function (track) {
      if (!once(track, 'Marquee')) return;
      track.innerHTML += track.innerHTML;
    });
  };

  /* ---------- deferred video ---------- */
  FC.video = function (scope) {
    $$('[data-video-trigger]', scope).forEach(function (btn) {
      if (!once(btn, 'Video')) return;
      btn.addEventListener('click', function () {
        var frame = btn.closest('[data-video-frame]');
        var src = frame && frame.getAttribute('data-video-src');
        if (!src) return;
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1');
        iframe.setAttribute('title', frame.getAttribute('data-video-title') || 'Video');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.setAttribute('loading', 'lazy');
        frame.innerHTML = '';
        frame.appendChild(iframe);
      });
    });
  };

  /* ---------- quantity ---------- */
  FC.quantity = function (scope) {
    $$('[data-quantity]', scope).forEach(function (widget) {
      if (!once(widget, 'Quantity')) return;
      var input = $('input', widget);
      $$('button', widget).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-qty') === 'plus' ? 1 : -1;
          var value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  };

  /* ---------- product variants + gallery ---------- */
  FC.product = function (scope) {
    $$('[data-product-form]', scope).forEach(function (root) {
      if (!once(root, 'Product')) return;
      var dataEl = $('[data-variant-json]', root);
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = $('[data-variant-id]', root);
      var priceEl = $('[data-price]', root);
      var submit = $('[data-add-to-cart]', root);
      var submitText = submit ? $('[data-add-to-cart-text]', submit) : null;

      function update() {
        var chosen = $$('input[type="radio"]:checked', root).map(function (i) { return i.value; });
        var match = variants.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        })[0];
        if (!match) {
          if (submit) { submit.disabled = true; }
          if (submitText) submitText.textContent = submit.getAttribute('data-unavailable-text') || 'Unavailable';
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
        if (submit) {
          submit.disabled = !match.available;
          if (submitText) {
            submitText.textContent = match.available
              ? submit.getAttribute('data-add-text') || 'Add to cart'
              : submit.getAttribute('data-sold-out-text') || 'Sold out';
          }
        }
        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }
      function markSelected() {
        $$('.variant-value', root).forEach(function (label) {
          var input = label.querySelector('input[type="radio"]');
          label.classList.toggle('is-selected', !!(input && input.checked));
        });
      }
      root.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) { markSelected(); update(); }
      });
      markSelected();
      update();
    });

    $$('[data-gallery]', scope).forEach(function (gallery) {
      if (!once(gallery, 'Gallery')) return;
      var main = $('[data-gallery-main] img', gallery);
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.getAttribute('data-src');
          main.srcset = thumb.getAttribute('data-srcset') || '';
          main.alt = thumb.getAttribute('data-alt') || '';
          $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
        });
      });
    });
  };

  /* ---------- booking calendar ---------- */
  FC.calendar = function (scope) {
    $$('[data-calendar]', scope).forEach(function (root) {
      if (!once(root, 'Calendar')) return;
      var grid = $('[data-calendar-grid]', root);
      var label = $('[data-calendar-label]', root);
      var output = $('[data-calendar-selected]', root);
      var links = $$('[data-calendar-link]', root.closest('.shopify-section') || root);
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var view = new Date(today.getFullYear(), today.getMonth(), 1);
      var selected = null;
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      function iso(date) {
        return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      }
      function render() {
        if (label) label.textContent = months[view.getMonth()] + ' ' + view.getFullYear();
        grid.innerHTML = '';
        ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].forEach(function (d) {
          var head = document.createElement('div');
          head.className = 'calendar__dow';
          head.textContent = d;
          grid.appendChild(head);
        });
        var first = new Date(view.getFullYear(), view.getMonth(), 1);
        var offset = (first.getDay() + 6) % 7;
        var days = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
        for (var i = 0; i < offset; i++) grid.appendChild(document.createElement('div'));
        for (var day = 1; day <= days; day++) {
          var date = new Date(view.getFullYear(), view.getMonth(), day);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'calendar__day';
          btn.textContent = day;
          btn.setAttribute('aria-label', day + ' ' + months[view.getMonth()] + ' ' + view.getFullYear());
          if (date < today) {
            btn.disabled = true;
          } else {
            btn.setAttribute('aria-pressed', String(selected === iso(date)));
            btn.addEventListener('click', pick.bind(null, date));
          }
          grid.appendChild(btn);
        }
      }
      function pick(date) {
        selected = iso(date);
        if (output) {
          output.textContent = date.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
        }
        links.forEach(function (link) {
          var base = link.getAttribute('data-href') || link.getAttribute('href');
          if (!link.getAttribute('data-href')) link.setAttribute('data-href', base);
          if (base && base !== '#') {
            link.setAttribute('href', base + (base.indexOf('?') === -1 ? '?' : '&') + 'date=' + selected);
          }
        });
        render();
      }
      $$('[data-calendar-prev]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var candidate = new Date(view.getFullYear(), view.getMonth() - 1, 1);
          if (candidate < new Date(today.getFullYear(), today.getMonth(), 1)) return;
          view = candidate; render();
        });
      });
      $$('[data-calendar-next]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render();
        });
      });
      render();
    });
  };

  /* ---------- sticky CTA spacing ---------- */
  FC.stickyCta = function (scope) {
    if ($('[data-sticky-cta]', scope || document)) document.body.classList.add('has-sticky-cta');
  };

  function init(scope) {
    Object.keys(FC).forEach(function (key) {
      try { FC[key](scope || document); } catch (e) { console.warn('[flutter-care] ' + key, e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var trigger = e.target.querySelector('.accordion__trigger');
    if (trigger && trigger.getAttribute('aria-expanded') === 'false') trigger.click();
  });
})();
